import {Component, Input, OnInit} from '@angular/core';
import {SpecLineModel} from '../../../properties/models/spec-line.model';
import {PropertiesQuery} from 'common-shared';

@Component({
  selector: 'app-spec-lines-view',
  templateUrl: './spec-lines-view.component.html',
  styles: [
  ]
})
export class SpecLinesViewComponent implements OnInit {
  @Input() specs: SpecLineModel[] = [];
  @Input() inline: boolean = true;

  constructor(public propertiesQuery: PropertiesQuery) { }

  ngOnInit(): void {
  }

}
